import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import TextField from '@material-ui/core/TextField';
import LoaderButton from '../../../shared/components/LoaderButton/LoaderButton';
import Back from '../../../shared/components/Back/Back';
import usernameSchema from '../../schemas/usernameSchema';
import styles from './usernameForm.module.scss';

export default memo(function UsernameForm(props) {
    const { t } = useTranslation(['common', 'validations', 'auth']);
    const backURL = props.location.pathname.includes('admin') ? '/signin/admin' : '/signin';

    return (
        <div className={styles.container}>
            <div className={styles.formContainer}>
                <span className={styles.description}>{t('auth:RECOVER_PASSWORD_USERNAME')}</span>
                <Formik
                    initialValues={{ username: '' }}
                    validationSchema={usernameSchema}
                    onSubmit={values => props.checkUsernameRequest(values.username, props.history, props.location)}
                    render={formProps => (
                        <Form>
                            <div className={styles.fieldsContainer}>
                                <TextField
                                    className={styles.field}
                                    disabled={props.isSending}
                                    error={formProps.touched.username && !!formProps.errors.username}
                                    helperText={
                                        formProps.touched.username && !!formProps.errors.username
                                            ? <span>{t('validations:REQUIRED')}</span>
                                            : ''
                                    }
                                    label={t('common:USER')}
                                    name="username"
                                    onBlur={formProps.handleBlur}
                                    onChange={formProps.handleChange}
                                    type="text"
                                    value={formProps.values.username}
                                />
                            </div>
                            <div className={styles.sendButton}>
                                <LoaderButton dictionary="common" inProgress={props.isSending} text="SEND" />
                            </div>
                        </Form>
                    )}
                />
            </div>
            <div className={styles.backContainer}>
                <div className={styles.lineContainer}>
                    <hr />
                </div>
                <Back url={backURL} />
            </div>
        </div>
    );
}, (prevProps, nextProps) => prevProps.isSending === nextProps.isSending);
